var map = {
	"./common/Reducer": 9001,
	"./complementary/Reducer": 32755,
	"./course/Reducer": 12279,
	"./customer/Reducer": 89867,
	"./dashboard/Reducer": 97634,
	"./discount/Reducer": 80386,
	"./download/Reducer": 70174,
	"./employee/Reducer": 34543,
	"./login/Reducer": 40173,
	"./menu/Reducer": 76009,
	"./modifier/Reducer": 58662,
	"./offer/Reducer": 44259,
	"./product/Reducer": 44940,
	"./report/Reducer": 58350,
	"./reward/Reducer": 88734,
	"./service/Reducer": 59535,
	"./setting/Reducer": 79430,
	"./stock/Reducer": 75047,
	"./supplier/Reducer": 18122,
	"./table/Reducer": 79474,
	"./transaction/Reducer": 75368,
	"./user/Reducer": 34163,
	"./warranty/Reducer": 26430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68379;